/**
 * ProductGroupAttributeValue - one selectable option value of an attribute (e.g. "S", "Azul").
 */
export class ProductGroupAttributeValue {
  constructor(data = {}) {
    this.id = data.id || null;
    this.code = data.code || null;
    this.name = data.name || null;
    this.position = data.position !== undefined && data.position !== null ? data.position : 0;
    this.hexColor = data.hexColor || null;
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    return new ProductGroupAttributeValue({
      id: json.id,
      code: json.code,
      name: json.name,
      position: json.position,
      hexColor: json.hexColor,
    });
  }

  toJSON() {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      position: this.position,
      hexColor: this.hexColor,
    };
  }
}
